import { Dialog, DialogContent, Stack, Typography, Button } from '@mui/material_modern'
import { useTheme } from '@mui/material/styles'
import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'

const CriticalDataErrorModal: React.FC = () => {
  const { criticalDataLoadingError } = useAppSelector(state => state.loading)

  const theme = useTheme()

  return (
    <Dialog
      open={criticalDataLoadingError}
      disableEscapeKeyDown
      sx={{
        '& .MuiDialog-paper': {
          backgroundColor: theme.palette.background.paper,
        },
      }}
    >
      <DialogContent>
        <Stack spacing={2} alignItems="center" justifyContent="center">
          <Typography variant="h6" sx={{ color: theme.palette.text.primary }}>
            Something went wrong while loading
          </Typography>
          <Typography variant="body1" align="center" sx={{ color: theme.palette.text.primary }}>
            We had trouble connecting to part of the system. Try refreshing the page.
            <br />
            If the issue continues, please reach out to your GreenSpark representative for help.
          </Typography>
          <Stack direction="column" spacing={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => window.location.reload()}
              sx={{ width: '200px' }}
            >
              Refresh
            </Button>
          </Stack>
        </Stack>
      </DialogContent>
    </Dialog>
  )
}

export default CriticalDataErrorModal
